export default function locatorString({ id = null, type = null }) {
  if (!id || !type) {
    console.warn("Missing id or type for locator");
  }

  return `${type}-${id}`;
}
